import React, { useEffect } from 'react';
import '../../../styles/mainContents.css'
import { fetchInventory, fetchCustomers, fetchTransfers, fetchOrders } from '../../../redux/actions/PostActions';

import { useSelector, useDispatch, connect } from 'react-redux';
import { Link, Switch, useHistory } from 'react-router-dom';

function StatusUpdate(props) {

  const dispatch = useDispatch();

  const { statusErrState, fetch_landingPageStates, custServerResponseState, transferServerResponseState, statusNoticeState, orderServerResponseState, authreducerState } = props;

  return (

    <div>
         
        <div className='statusUpdatesId'>
        
        { statusErrState !== undefined &&
              statusErrState.length > 0 ?
              <React.Fragment>
                {
                  statusErrState.map((errMessage, i) => {
                    return <div className='statusUpdatesFailed' key={i}>{errMessage}</div> 
                  })

                }
              </React.Fragment>

             
            : ''
          }

          { statusNoticeState !== undefined &&
              statusNoticeState.length > 0 ?
                <div className='statusUpdateNotice'>
                  {statusNoticeState}
                  {fetch_landingPageStates(authreducerState.user)}
                </div>              
            : ''
          }

          { 
            orderServerResponseState !== undefined && 
              Object.keys(orderServerResponseState).length > 0 ?
                <div>
                  {
                    orderServerResponseState['FAILED_UPDATES'].length > 0 ?
                      <div className='statusUpdatesFailed'> 
                        {orderServerResponseState['FAILED_UPDATES']}
                      </div>
                    : ''
                  }

                  {
                    orderServerResponseState['SUCCESSFUL_UPDATES'] !== '' ? 
                      <div className='statusUpdatesSuccess'>
                        {orderServerResponseState['SUCCESSFUL_UPDATES']}
                      </div>
                  : ''
                  }
                </div>               
            : ''
          }  

          { 
            transferServerResponseState !== undefined && 
              Object.keys(transferServerResponseState).length > 0 ?
                <div>
                  {
                    transferServerResponseState['FAILED_UPDATES'].length > 0 ?
                      <div className='statusUpdatesFailed'> 
                        {transferServerResponseState['FAILED_UPDATES']}
                      </div>
                    : ''
                  }

                  {
                    transferServerResponseState['SUCCESSFUL_UPDATES'] !== '' ? 
                      <div className='statusUpdatesSuccess'>
                        {transferServerResponseState['SUCCESSFUL_UPDATES']}
                      </div>
                  : ''
                  }
                </div>               
            : ''
          } 

          { 
            custServerResponseState !== undefined && 
              Object.keys(custServerResponseState).length > 0 ?
                <div>
                  {
                    custServerResponseState['FAILED_UPDATES'].length > 0 ?
                      <div className='statusUpdatesFailed'> 
                        {custServerResponseState['FAILED_UPDATES']}
                      </div>
                    : ''
                  }

                  {
                    custServerResponseState['SUCCESSFUL_UPDATES'] !== '' ? 
                      <div className='statusUpdatesSuccess'>
                        {custServerResponseState['SUCCESSFUL_UPDATES']}
                      </div>
                  : ''
                  }
                </div>               
            : ''
          }             
        </div>

        
    </div>

  );
}



const mapStateToProps = (state) => {

 return {
  statusNoticeState: state.statusUpdateReducer['items_statusNotices'],
  statusErrState: state.statusUpdateReducer['items_statusErr'],
  orderServerResponseState: state.statusUpdateReducer['orderServerResponse'], 
  transferServerResponseState: state.statusUpdateReducer['transferServerResponse'],
  custServerResponseState: state.statusUpdateReducer['custServerResponse'],    

  authreducerState: state.authreducer

 }

};

const mapDispatchToProps = (dispatch) => {

  return {
    fetch_landingPageStates: (user) => {
      dispatch(fetchOrders(user));
      dispatch(fetchTransfers(user));
      dispatch(fetchCustomers(user));
      dispatch(fetchInventory(user));
    },   
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StatusUpdate);